import React from 'react'
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { TextField } from '@mui/material'
import isSameDay from 'date-fns/isSameDay'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'

const MultiSelectDatePicker = ({
  selectedDates = [],
  onDatesChange,
  label = 'Select Dates',
  date,
  setDate,
  year,
  month,
  sx = {
    '& .MuiFormControl-root': {
      width: '100%',
      Padding: 0,
    },
    '& .MuiInputBase-root': {
      height: 35,
      overflow: 'hidden',
    },
  },
}) => {
  const startDate = new Date(year, month, 1)
  const endDate = new Date(year, month + 1, 0)

  const handleDateChange = (date) => {
    if (date && !selectedDates?.some((selectedDate) => isSameDay(selectedDate, date))) {
      onDatesChange([...selectedDates, date])
    }

    setDate(date)
  }

  const handleDeleteDate = (dateToDelete) => {
    onDatesChange(selectedDates.filter((date) => !isSameDay(date, dateToDelete)))
  }

  const getDynamicStyles = (day) => {
    const isSelected = selectedDates?.some((selectedDate) => isSameDay(selectedDate, day))
    if (isSelected) {
      return {
        color: 'white',
        backgroundColor: '#8bc34a',
      }
    }

    return {
      color: 'gray',
      backgroundColor: 'white',
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DemoContainer sx={{ ...sx, minWidth: 180 }} components={['DatePicker']}>
        <div style={{ maxWidth: 240 }}>
          <DatePicker
            closeOnSelect={true}
            viewRenderers={undefined}
            label={label}
            value={date}
            onChange={handleDateChange}
            renderInput={(params) => <TextField {...params} readOnly />}
            slotProps={{
              day: (params) => ({
                sx: getDynamicStyles(params.day),
              }),
              textField: {
                size: 'small',
                fullWidth: true,
                variant: 'outlined',
                color: 'secondary',
              },
            }}
            openTo="day"
            minDate={startDate}
            maxDate={endDate}
          />
        </div>
      </DemoContainer>
    </LocalizationProvider>
  )
}

export default MultiSelectDatePicker
